module.exports = __webpack_public_path__ + "static/AndelliaDavilton-26edbb020343a718c214bf3b5dccdf74.otf";